<template lang="html">
  <div class="row encounter-slide">
    <div v-if="treatment_plan" class="tp-title col-12">
      <h5><strong>{{ treatment_plan.Heading }}</strong></h5>
      <p><em>
        treatment plan prepared 
        <span v-if="pat_name">for {{ pat_name }}</span> 
        <span v-if="treatment_plan.SecDateTEdit"> on {{ treatment_plan.SecDateTEdit | prettyDateShortFromDT }}</span>
      </em></p>
    </div> <!-- /.tp-title -->

    <div class="slide-body col-12">
      <h1 class="text-center">What happens if we wait?</h1>

      <div v-if="decideGoalDisplay(validGoals[0])" class="box-chart align-items-center">
        <div class="goal-key"><span class="light-weight">Goal</span><br>{{ validGoals[0] }}</div>
        <h5 class="text-center">Appearance is lost as small problems get worse. Health is beautiful!</h5>
        <img class="img-fluid" src="../assets/img/chart-goal-appearance.png" alt="chart of loss of appearance as disease increases over time" />
      </div> <!-- /.box-chart -->

      <div v-if="decideGoalDisplay(validGoals[1]) || decideGoalDisplay(validGoals[2])" class="box-chart align-items-center">
        <div v-if="decideGoalDisplay(validGoals[1])" class="goal-key"><span class="light-weight">Goal</span><br>{{ validGoals[1] }}</div>
        <div v-if="decideGoalDisplay(validGoals[2])" class="goal-key"><span class="light-weight">Goal</span><br>{{ validGoals[2] }}</div>
        <h5 class="text-center">Small issues can become bigger ones over time. This helps us stay ahead of it.</h5>
        <img class="img-fluid" src="../assets/img/chart-goal-function.png" alt="chart of loss of function as disease increases over time" />
      </div> <!-- /.box-chart -->

      <div v-if="decideGoalDisplay(validGoals[3])" class="box-chart align-items-center">
        <div class="goal-key"><span class="light-weight">Goal</span><br>{{ validGoals[3] }}</div>
        <h5 class="text-center">Addressing small problems now avoids higher costs in the future.</h5>
        <img class="img-fluid" src="../assets/img/chart-goal-avoid-costs.png" alt="chart of increasing costs as disease increases over time" />
      </div> <!-- /.box-chart -->
      
      <div v-if="decideGoalDisplay(validGoals[4])" class="box-chart align-items-center">
        <div class="goal-key"><span class="light-weight">Goal</span><br>{{ validGoals[4] }}</div>
        <h5 class="text-center">As symptoms worsen, anxiety can get worse too. Put your mind at ease!</h5>
        <img class="img-fluid" src="../assets/img/chart-goal-anxiety.png" alt="chart of increasing anxiety as symptoms worsen over time" />
      </div> <!-- /.box-chart -->

      <div v-if="decideGoalDisplay(validGoals[5])" class="box-chart align-items-center">
        <div class="goal-key"><span class="light-weight">Goal</span><br>{{ validGoals[5] }}</div>
        <h5 class="text-center">Regular care helps prevent bigger problems. Let's make a plan!</h5>
        <img class="img-fluid" src="../assets/img/chart-goal-long-term-care.png" alt="chart of reduced problems with more frequent visits" />
      </div> <!-- /.box-chart -->

      <div v-if="decideGoalDisplay(validGoals[6])" class="box-chart align-items-center">
        <div class="goal-key"><span class="light-weight">Goal</span><br>{{ validGoals[6] }}</div>
        <h5 class="text-center">Pain increases as problems get worse. We can help!</h5>
        <img class="img-fluid" src="../assets/img/chart-goal-function.png" alt="chart of loss of function as disease increases over time" />
      </div> <!-- /.box-chart -->

      <div class="box-chart align-items-center">
        <img class="img-fluid" src="../assets/img/chart-procedure-expense.png" alt="chart of increasing costs by procedure" />
      </div> <!-- /.box-chart -->
      
      <hr class="hr-dark-color" />
      <p class="text-center"><button @click.prevent="markSlideAndForward" class="btn btn-green btn-lg">Let's Stop Things From Getting Worse!<i class="fas fa-angle-right fa-fw"></i></button></p>
    </div> <!-- /.slide-body -->

  </div> <!-- /.encounter-slide -->
</template>

<script>
import Vue from 'vue'
import {mapGetters} from 'vuex'
import ImageGallery from '../components/ImageGallery.vue'

export default {
  props: ['encounterData'],
  components: {
    ImageGallery,
  },
  data() {
    return {
      validGoals: [
        "A better looking smile",
        "Making teeth last for the long run",
        "Teeth functioning better",
        "Avoiding high costs",
        "Less anxiety about care",
        "Long term care partner",
        "Help with current pain",
      ],
    };
  },
  computed: {
    ...mapGetters(['user', 'user_props', 'custom_claims', 'appointment', 'encounter','treatment_plan', 'pat_num', 'pat_name']),
  },
  watch: {
    
  },
  methods: {
    markSlideAndForward() {
      // this.$emit('update-encounter-data', {
      //   slides_completed: [
      //     ...this.encounterData.slides_completed,
      //     this.$route.name,
      //   ],
      // });
      this.$emit('forward')
    },
    decideGoalDisplay(goal) {
      if(
          (this.encounterData.patGoal && this.encounterData.patGoal.length) &&
          (
            this.encounterData.patGoal.includes(goal) ||
            this.encounterData.patGoal === goal
          )
      ) {
        return true;
      }
    },
  },
}
</script>

<style lang="less" scoped>
@import "../assets/less/variables.less";

h1 {
  margin-bottom: 20px;
}
.tp-title {
  text-align: center;
  padding: 20px;
  border-bottom: 1px solid @dark-color;
  margin-bottom: 30px;

  h5,p {
    margin: 0;
  }
}
h5 {
  margin-bottom: 30px;
}
.encounter-slide {
  padding: 0;
}
.slide-body {
  padding: 0 30px 30px;
}
hr {
  margin: 0 0 30px;
}
.box-chart {
  margin-bottom: 30px;
  position: relative;
}
.goal-key {
  position: absolute;
  top: 74px;
  left: 30px;
  width: 125px;
  z-index: 5;
  font-size: 16px;
  line-height: 20px;
  font-weight: bold;
  text-transform: capitalize;
}
</style>
